import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class VersionService {

    private currentVersion: string = '';

    constructor(
        private http: Http
    ) {

    }

    public isChangedVersion(): Observable<boolean>
    {
        return this.getVersion().pipe(
            map(res => {
                if (!this.currentVersion) {
                    this.currentVersion = res;
                }
                return this.currentVersion !== res;
            }),
            catchError(error => {
                return of(false);
            }),
        )
    }

    public getVersion(): Observable<string> {
        return this.http.get('version.txt?t=' + new Date().getTime()).pipe(
            map((res: any) => {
                return res._body ? res._body : '';
            })
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/version.service.ts